// removed by extract-text-webpack-plugin
module.exports = {"wrap":"rec_c_z7iFA6o","wrap_content_item":"rec_c_3MNql1Y","hover_img":"rec_c_2q26_He"};


//////////////////
// WEBPACK FOOTER
// ./src/component/rec/rec_c.css
// module id = 846
// module chunks = 0